import { useContext } from "react";
import { AlertContext } from "./alert.context";

/**
 * Hook to access alert service
 * Usage: const { show, hide } = useAlert();
 * show("Saved", { type: "success", timeout: 4000 })
 */
export default function useAlert() {
    const ctx = useContext(AlertContext);
    if (!ctx) {
        throw new Error("useAlert must be used within an AlertProvider");
    }
    return {
        show: ctx.show,
        hide: ctx.hide,
        // expose alerts if needed
        alerts: ctx.alerts,
    };
}
